export default __webpack_public_path__ + "static/media/live-dot.bc5b8ed2.gif";